import {
  AppActionTypes,
  NodeActionTypes,
  SetCurrentFolderAction,
  SetCurrentNodeVersionAction,
  SetInfoDrawerMetadataAspectAction,
  SetUserProfileAction,
} from '@alfresco/aca-shared/store';
import { Action } from '@ngrx/store';

import { KeywordConstant, CommonConstants } from '../../shared';
import {
  ADD_NEW_KEYWORD,
  AddNewKeyword,
  COPY_KEYWORD,
  CopyKeyword,
  EDIT_COPY_KEYWORD,
  EDIT_KEYWORD,
  EditCopiedKeyword,
  EditKeyword,
  SELECT_KEYWORD,
  DELETE_KEYWORD,
  DeleteKeywordAction,
  SELECTED_FOR_DELETE,
  SelectedForDeleteAction,
  SET_CONTENT_WIDGET_ASSIGNEE_STATE,
  SET_CURRENT_SITE,
  SET_DOCUMENT_KEYWORD,
  SET_SITES_ACTION,
  SET_SITES_MANAGER,
  SET_SITE_CHILDREN,
  SelectKeyword,
  SetBpmUser,
  SetBpmUserAction,
  SetContentWidgetAssigneeStateAction,
  SetCurrentSiteAction,
  SetCurrentUrlAction,
  SetInfoDrawerStateAction,
  SetKeyWordAction,
  SetRepositoryInfoAction,
  SetSelectedNodesAction,
  SetSiteChildrenAction,
  SetSiteManagerAction,
  SetSitesAction,
  SetDefinitionEditorAction,
  SetKeywordEditorAction,
  SET_DEFINITION,
  SET_KEYWORD,
  ReorderKeywordAction,
  REORDER_KEYWORD,
  KEYWORD_UNDO_REDO,
  KeywordUndoRedoAction,
  KEYWORD_TRAVERSE,
  KeywordTraverseAction,
  ALL_DOCS_DASHBOARD_ADD_ITEM,
  ALL_DOCS_DASHBOARD_REMOVE_ITEM,
  ALL_DOCS_DASHBOARD_DESELECT_ALL,
  AllDocsDashboardAddItemAction,
  AllDocsDashboardRemoveItemAction,
  SET_USER_ROLE_FOR_CURRENT_SITE,
  SetUserRoleForCurrentSiteAction,
  ShowLoaderAction,
  SetCitationsData,
  SET_CITATIONS_DATA,
  SetLatestEditorContentAction,
  SET_LATEST_EDITOR_CONTENT,
  SetPaginationChange,
  ON_PAGINATION_CHANGE,
  SET_PAGINATION_DATA,
  SetPaginationData,
  SET_UPLOAD_COMPLETED,
  SetUploadCompletedAction,
  SET_DIALOG_DATA,
  SetTargetDeleteDialogData,
  SET_FEATURE_FLAGS,
  SetFeatureFlags,
  SET_SELECTED_DOCUMENTS,
  SetSelectedDocumentsAction,
  SET_ROWS_DATA,
  SetRowsDataAction,
} from '../actions/app.custom-actions';
import {
  AppState,
  IAltLabelForKeyword,
  IKeyWord,
  IKeyWords,
  IKeywordDefinition,
  INITIAL_APP_STATE,
} from '../states';
import { DiacriticSort } from '../../utils';

export function appReducer(
  state: AppState = INITIAL_APP_STATE,
  action: Action
): AppState {
  let newState: AppState;

  switch (action.type) {
    case NodeActionTypes.SetSelection:
      newState = updateSelectedNodes(state, action as SetSelectedNodesAction);
      break;
    case AppActionTypes.SetUserProfile:
      newState = updateUser(state, action as SetUserProfileAction);
      break;
    case AppActionTypes.SetCurrentFolder:
      newState = updateCurrentFolder(state, action as SetCurrentFolderAction);
      break;
    case AppActionTypes.SetCurrentVersion:
      newState = updateCurrentNodeVersion(
        state,
        action as SetCurrentNodeVersionAction
      );
      break;
    case AppActionTypes.SetCurrentUrl:
      newState = updateCurrentUrl(state, action as SetCurrentUrlAction);
      break;
    case AppActionTypes.ToggleInfoDrawer:
      newState = toggleInfoDrawer(state);
      break;
    case AppActionTypes.SetInfoDrawerState:
      newState = setInfoDrawer(state, action as SetInfoDrawerStateAction);
      break;
    case AppActionTypes.SetInfoDrawerMetadataAspect:
      newState = setInfoDrawerAspect(
        state,
        action as SetInfoDrawerMetadataAspectAction
      );
      break;
    // case AppActionTypes.ToggleDocumentDisplayMode:
    //   newState = toggleDocumentDisplayMode(state);
    //   break;
    case AppActionTypes.SetRepositoryInfo:
      newState = updateRepositoryStatus(
        state,
        action as SetRepositoryInfoAction
      );
      break;
    case SET_SITES_ACTION:
      newState = setSites(state, action as SetSitesAction);
      break;
    case SET_CURRENT_SITE:
      newState = setCurrentSite(state, action as SetCurrentSiteAction);
      break;
    case SET_CONTENT_WIDGET_ASSIGNEE_STATE:
      newState = setContentWidgetAssigneeState(
        state,
        action as SetContentWidgetAssigneeStateAction
      );
      break;
    case SET_SITE_CHILDREN:
      newState = setSiteChildren(state, action as SetSiteChildrenAction);
      break;
    case SET_SITES_MANAGER:
      newState = setSiteManager(state, action as SetSiteManagerAction);
      break;
    case SetBpmUser:
      newState = updateBpmUser(state, action as SetBpmUserAction);
      break;
    case SET_DOCUMENT_KEYWORD:
      newState = setKeyword(state, action as SetKeyWordAction);
      break;
    case ADD_NEW_KEYWORD:
      newState = addKeyword(state, action as AddNewKeyword);
      break;
    case SELECT_KEYWORD:
      newState = setSelectedKeyword(state, action as SelectKeyword);
      break;
    case EDIT_KEYWORD:
      newState = editKeyword(state, action as EditKeyword);
      break;
    case COPY_KEYWORD:
      newState = {
        ...state,
        keyWords: {
          ...state.keyWords,
          copyKeyword: (action as CopyKeyword).payload,
        },
      };
      break;
    case EDIT_COPY_KEYWORD:
      newState = editCopiedKeyword(state, action as EditCopiedKeyword);
      break;
    case SET_DEFINITION:
      newState = setDefinitionEditor(
        state,
        action as SetDefinitionEditorAction
      );
      break;
    case SET_KEYWORD:
      newState = setKeywordEditor(state, action as SetKeywordEditorAction);
      break;
    case REORDER_KEYWORD:
      newState = reorderKeyword(state, action as ReorderKeywordAction);
      break;
    case DELETE_KEYWORD:
      newState = deleteKeyword(state, action as DeleteKeywordAction);
      break;
    case SELECTED_FOR_DELETE:
      newState = selectedForDelete(state, action as SelectedForDeleteAction);
      break;
    case KEYWORD_UNDO_REDO:
      newState = keywordUndoRedo(state, action as KeywordUndoRedoAction);
      break;
    case KEYWORD_TRAVERSE:
      newState = traverseKeyword(state, action as KeywordTraverseAction);
      break;
    case ALL_DOCS_DASHBOARD_ADD_ITEM:
      newState = AllDocsDashboardAddItem(
        state,
        action as AllDocsDashboardAddItemAction
      );
      break;
    case ALL_DOCS_DASHBOARD_REMOVE_ITEM:
      newState = AllDocsDashboardRemoveItem(
        state,
        action as AllDocsDashboardRemoveItemAction
      );
      break;
    case ALL_DOCS_DASHBOARD_DESELECT_ALL:
      newState = AllDocsDashboardDeselectAll(state);
      break;
    case SET_USER_ROLE_FOR_CURRENT_SITE:
      newState = SetUserRoleForCurrentSite(
        state,
        action as SetUserRoleForCurrentSiteAction
      );
      break;
    case AppActionTypes.ShowLoaderAction:
      newState = showLoader(state, action as ShowLoaderAction);
      break;
    case SET_CITATIONS_DATA:
      newState = {
        ...state,
        citations: (action as SetCitationsData).payload,
      };
      break;
    case SET_LATEST_EDITOR_CONTENT:
      newState = {
        ...state,
        latestEditorContent: (action as SetLatestEditorContentAction).payload,
      };
      break;
    case ON_PAGINATION_CHANGE:
      newState = {
        ...state,
        pagination: (action as SetPaginationChange).payload,
      };
      break;
    case SET_PAGINATION_DATA:
      newState = {
        ...state,
        paginationData: (action as SetPaginationData).payload,
      };
      break;
    case SET_UPLOAD_COMPLETED:
      newState = {
        ...state,
        uploadCompleted: (action as SetUploadCompletedAction).payload,
      };
      break;
    case SET_DIALOG_DATA:
      newState = {
        ...state,
        targetDeleteDialogData: (action as SetTargetDeleteDialogData).payload,
      };
      break;
    case SET_FEATURE_FLAGS:
      newState = {
        ...state,
        featureFlagsState: (action as SetFeatureFlags).payload,
      };
      break;
    case SET_SELECTED_DOCUMENTS:
      newState = {
        ...state,
        selectedDocumentState: [
          ...(action as SetSelectedDocumentsAction).payload,
        ],
      };
      break;
    case SET_ROWS_DATA:
      newState = {
        ...state,
        selectedRowsState: (action as SetRowsDataAction).payload,
      };
      break;
    default:
      newState = { ...state };
  }
  return newState;
}

function updateUser(state: AppState, action: SetUserProfileAction): AppState {
  const newState = { ...state };
  const user = action.payload.person;
  const groups = [...(action.payload.groups || [])];

  const id = user.id;
  const firstName = user?.firstName || '';
  const lastName = user.lastName || '';
  const userName = `${firstName} ${lastName}`;
  const initials = [firstName[0], lastName[0]].join('');

  const capabilities = user.capabilities;
  const isAdmin = capabilities ? capabilities.isAdmin : true;

  newState.user = {
    firstName,
    lastName,
    userName,
    initials,
    isAdmin,
    id,
    groups,
  };

  return newState;
}

function updateCurrentFolder(state: AppState, action: SetCurrentFolderAction) {
  const newState = { ...state };
  newState.navigation.currentFolder = action.payload;
  return newState;
}

function updateCurrentNodeVersion(
  state: AppState,
  action: SetCurrentNodeVersionAction
) {
  const newState = { ...state };
  newState.currentNodeVersion = action.payload;
  return newState;
}

function updateCurrentUrl(state: AppState, action: SetCurrentUrlAction) {
  const newState = { ...state };
  newState.navigation.url = action.payload;
  return newState;
}

function toggleInfoDrawer(state: AppState) {
  const newState = { ...state };

  let value = state.infoDrawerOpened;
  if (state.selection.isEmpty) {
    value = false;
  } else {
    value = !value;
  }
  newState.infoDrawerOpened = value;

  return newState;
}

function updateSelectedNodes(
  state: AppState,
  action: SetSelectedNodesAction
): AppState {
  const newState = { ...state };
  const nodes = [...action.payload];
  const count = nodes.length;
  const isEmpty = nodes.length === 0;

  let first = null;
  let last = null;
  let file = null;
  let folder = null;
  let library = null;

  if (nodes.length > 0) {
    first = nodes[0];
    last = nodes[nodes.length - 1];

    if (nodes.length === 1) {
      file = nodes.find((entity: any) => {
        // workaround Shared
        return !!(
          entity?.entry?.isFile ||
          entity?.entry?.nodeId ||
          entity?.entry?.sharedByUser
        );
      });
      folder = nodes.find((entity: any) => entity?.entry?.isFolder);
    }
  }

  const libraries: any[] = [...action.payload].filter(
    (node: any) => node.isLibrary
  );
  if (libraries.length === 1) {
    library = libraries[0];
  }

  if (isEmpty) {
    if (localStorage.getItem('infoDrawerOpened')) {
      newState.infoDrawerOpened = true;
      localStorage.removeItem('infoDrawerOpened');
    } else {
      newState.infoDrawerOpened = false;
    }
  }

  newState.selection = {
    count,
    nodes,
    isEmpty,
    first,
    last,
    file,
    folder,
    libraries,
    library,
  };
  return newState;
}

function setInfoDrawer(state: AppState, action: SetInfoDrawerStateAction) {
  const newState = {
    ...state,
    infoDrawerOpened: action.payload,
  };
  if (localStorage.getItem('infoDrawerOpened')) {
    newState.infoDrawerOpened = true;
    localStorage.removeItem('infoDrawerOpened');
  } else {
    newState.infoDrawerOpened = action.payload;
  }
  return newState;
}

function setInfoDrawerAspect(
  state: AppState,
  action: SetInfoDrawerMetadataAspectAction
) {
  return {
    ...state,
    infoDrawerMetadataAspect: action.payload,
  };
}

function updateRepositoryStatus(
  state: AppState,
  action: SetRepositoryInfoAction
) {
  const newState = { ...state };
  newState.repository = action.payload;
  return newState;
}

function setSites(state: AppState, action: SetSitesAction) {
  const newState = { ...state };
  newState.sites = action.payload;
  return newState;
}

function setCurrentSite(state: AppState, action: SetCurrentSiteAction) {
  const newState = { ...state };
  newState.currentSite = action.payload;
  return newState;
}

function setContentWidgetAssigneeState(
  state: AppState,
  action: SetContentWidgetAssigneeStateAction
) {
  const newState = { ...state };
  newState.contentWidgetAssigneeState = action.payload;
  return newState;
}

function setSiteChildren(state: AppState, action: SetSiteChildrenAction) {
  const newState = { ...state };
  newState.siteChildren = action.payload;
  return newState;
}

function setSiteManager(state: AppState, action: SetSiteManagerAction) {
  const newState = { ...state };
  newState.isSiteManager = action.payload === 'SiteManager';
  return newState;
}

function updateBpmUser(
  state: AppState,
  { payload: { bpmUser } }: SetBpmUserAction
): AppState {
  return {
    ...state,
    bpmUser: {
      ...bpmUser,
      groups: bpmUser.groups ?? [],
    },
  };
}

/**
 * Use to set keyword on state on load keywors
 *
 * @param {AppState} state
 * @param {SetKeyWordAction} action
 * @returns {AppState}
 */
function setKeyword(state: AppState, action: SetKeyWordAction): AppState {
  return { ...state, keyWords: formatKeyword(action.payload) };
}

/**
 * Use to add new keyword in keywords
 *
 * @param {AppState} state
 * @param {AddNewKeyword} action
 * @returns {AppState}
 */
function addKeyword(state: AppState, action: AddNewKeyword): AppState {
  const {
    keyWords: { byId, formattedKeyword },
    editorUndo: { keywords },
  } = state;
  const undoKeyword = [...keywords, getKeywordForUndoRedo(state)];
  byId[action.payload.keyWordId] = action.payload;
  formattedKeyword.push(...formatKeyword([action.payload]).formattedKeyword);
  return {
    ...state,
    editorUndo: {
      keywords: [...undoKeyword],
    },
    keyWords: formatKeyword(sortKeyword(formattedKeyword, byId)),
  };
}

/**
 * formate keywords and return for new state
 *
 * @export
 * @param {IKeyWord[]} keywords
 * @returns {IKeyWords}
 */
export function formatKeyword(keywords: IKeyWord[]): IKeyWords {
  const allId = [];
  const byId = {};
  const _keywords: IKeyWord[] = [];
  const formattedKeyword = keywords.map((_keyword: IKeyWord, _: number) => {
    const inputKeyword: IKeyWord = {
      keyWordId: _keyword.keyWordId,
      keyWordString: _keyword.keyWordString
        .replace(/&lt;/g, '<')
        .replace(/&gt;/g, '>'),
    };
    _keywords.push(inputKeyword);
    const _html = new DOMParser().parseFromString(
      inputKeyword.keyWordString,
      'text/html'
    );
    const altLabels: IAltLabelForKeyword[] = Array.from(
      _html.querySelectorAll(`[rel='${KeywordConstant.keywordRel}']`)
    ).map(
      (label): IAltLabelForKeyword => ({
        content: label.firstElementChild.getAttribute(
          KeywordConstant.keywordContentProperty
        ),
        element: label,
        id: label.firstElementChild
          .getAttribute(KeywordConstant.keywordAboutProperty)
          .split('/')
          .slice(-1)[0],
        isPreferedLabel: false,
      })
    );
    const key = _html
      .querySelector(`[property='${KeywordConstant.keywordProperty}']`)
      .getAttribute(KeywordConstant.keywordContentProperty);
    const span = document.createElement(`${CommonConstants.spanTagName}`);
    span.innerHTML = key;
    const label = _html.querySelector(
      `[typeof="${KeywordConstant.keywordLabel}"]`
    );
    altLabels.unshift({
      content: key,
      element: label,
      id: label.getAttribute('id'),
      isPreferedLabel: true,
    });
    const formatted: IKeywordDefinition = {
      id: inputKeyword.keyWordId,
      name: span.textContent,
      keyTerm: key,
      definition: _html
        .querySelector(`[property='${KeywordConstant.keywordDefProperty}']`)
        .getAttribute(KeywordConstant.keywordContentProperty),
      altLabels,
      preferedLabelId: label.getAttribute('id'),
      altLabelsCount: altLabels.length,
    };
    allId.push(inputKeyword.keyWordId);
    byId[inputKeyword.keyWordId] = inputKeyword;
    return formatted;
  });
  return { allId, byId, formattedKeyword, allKeyword: _keywords };
}

/**
 * Use to set selected keyword/lebel from document
 *
 * @param {AppState} state
 * @param {SelectKeyword} action
 * @returns {AppState}
 */
function setSelectedKeyword(state: AppState, action: SelectKeyword): AppState {
  return {
    ...state,
    keyWords: { ...state.keyWords, selected: action.payload },
  };
}

/**
 * Use to edit an existing keyword in keywords.
 * @param {AppState} state,
 * @param {EditKeyword} action,
 * @returns {AppState}.
 */

function editKeyword(state: AppState, action: EditKeyword): AppState {
  const {
    keyWords,
    editorUndo: { keywords },
  } = state;
  const undoKeyword = [...keywords, getKeywordForUndoRedo(state)];
  const allKeyword = [...keyWords.allKeyword];
  // Find the index of the object with matching keyWordId.
  const indexToUpdate = allKeyword.findIndex(
    (obj) => obj.keyWordId === action.payload.keyWordId
  );
  const needToUpdate = allKeyword[indexToUpdate];
  const html = new DOMParser().parseFromString(
    needToUpdate.keyWordString,
    'text/html'
  );

  // Here we are setting/updatting old keyword content with new one.
  html
    .querySelector(`[property='${KeywordConstant.keywordProperty}']`)
    .setAttribute('content', action.payload.keyWord);
  // Here we are setting/updatting old definition content with new one.
  html
    .querySelector(`[property='${KeywordConstant.keywordDefProperty}']`)
    .setAttribute('content', action.payload.definition);
  allKeyword[indexToUpdate].keyWordString = html.body.innerHTML;
  return {
    ...state,
    editorUndo: { keywords: [...undoKeyword] },
    keyWords: formatKeyword(allKeyword),
  };
}

function editCopiedKeyword(
  state: AppState,
  action: EditCopiedKeyword
): AppState {
  const {
    keyWords,
    editorUndo: { keywords },
  } = state;
  const undoKeyword = [...keywords, getKeywordForUndoRedo(state)];
  const allKeyword = [...keyWords.allKeyword];
  allKeyword.find(
    (keyword) => keyword.keyWordId === action.payload.keyWordId
  ).keyWordString = action.payload.keyWordString;
  return {
    ...state,
    editorUndo: { keywords: [...undoKeyword] },
    keyWords: formatKeyword(allKeyword),
  };
}

/**
 * Use this to Delete the Keyword / Definition from Object
 * @param {AppState} state
 * @param {SelectKeyword} action
 * @returns {AppState}
 */
function deleteKeyword(state: AppState, action: DeleteKeywordAction): AppState {
  let {
    keyWords: { allKeyword, formattedKeyword },
    editorUndo: { keywords },
  } = state;
  const undoKeyword = [...keywords, getKeywordForUndoRedo(state)];
  let { docRefId, keyword, prefLabelExist } = action.payload;
  keyword = formattedKeyword.find((k) => k.id === keyword.id);
  if (keyword) {
    const keywordIndex = allKeyword.findIndex(
      (x) => x.keyWordId === keyword.id
    );
    const { altLabels } = formattedKeyword.find(
      (item) => item.id === keyword.id
    );
    const isPrefLabel =
      docRefId === 'all'
        ? true
        : altLabels.find((x) => x.id === docRefId) &&
          altLabels.find((x) => x.id === docRefId).isPreferedLabel;

    if (
      docRefId === 'all' ||
      keyword.altLabels.length === 1 ||
      (!isPrefLabel && altLabels.length === 2 && !prefLabelExist)
    ) {
      allKeyword = state.keyWords.allKeyword.filter(
        (item) => item.keyWordId !== keyword.id
      );
    } else {
      const prefLabelSelected =
        keyword.altLabels.length > 1 &&
        altLabels.find((x) => x.id === docRefId).isPreferedLabel;

      !prefLabelSelected &&
        (allKeyword[keywordIndex].keyWordString = toDeleteSelectedAltLabel(
          altLabels,
          docRefId,
          allKeyword,
          keywordIndex
        ));
    }
  }
  const _keywords = formatKeyword(allKeyword);
  return {
    ...state,
    editorUndo: { keywords: [...undoKeyword] },
    keyWords: formatKeyword(
      sortKeyword(_keywords.formattedKeyword, _keywords.byId)
    ),
  };
}

/**
 * This is called to delete alternate keyword
 * @param keywordAndDefinition
 * @param docRefId
 * @param allKeyword
 * @param keywordIndex
 * @returns
 */
function toDeleteSelectedAltLabel(
  altLabels,
  docRefId,
  allKeyword,
  keywordIndex
): string {
  const altLabel = altLabels.find((x) => x.id === docRefId).element.outerHTML;
  return allKeyword[keywordIndex].keyWordString.replace(altLabel, '');
}

function selectedForDelete(
  state: AppState,
  action: SelectedForDeleteAction
): AppState {
  return {
    ...state,
    keyWords: {
      ...state.keyWords,
      keywordForDelete: action.payload,
    },
  };
}

function setDefinitionEditor(
  state: AppState,
  action: SetDefinitionEditorAction
): AppState {
  return {
    ...state,
    keyWords: {
      ...state.keyWords,
      definition: action.payload,
    },
  };
}

function setKeywordEditor(
  state: AppState,
  action: SetKeywordEditorAction
): AppState {
  return {
    ...state,
    keyWords: {
      ...state.keyWords,
      keyword: action.payload,
    },
  };
}

const sortKeyword = (
  keywords: IKeywordDefinition[],
  byId: { [key: string]: IKeyWord }
) => {
  return DiacriticSort.sort<IKeywordDefinition>(keywords, 'name').map(
    (x) => byId[x.id]
  );
};

function reorderKeyword(state: AppState, _: ReorderKeywordAction) {
  const { formattedKeyword, byId } = state.keyWords;
  return {
    ...state,
    keyWords: formatKeyword(sortKeyword(formattedKeyword, byId)),
  };
}

function getKeywordForUndoRedo(state: AppState) {
  const {
    keyWords: { byId, allId, allKeyword, formattedKeyword },
  } = JSON.parse(JSON.stringify(state));
  return { byId, allId, allKeyword, formattedKeyword };
}

function keywordUndoRedo(
  state: AppState,
  action: KeywordUndoRedoAction
): AppState {
  const {
    editorRedo: {
      keywords: [...redoKeyword],
    },
    editorUndo: {
      keywords: [...undoKeyword],
    },
  } = state;
  const {
    payload: { operation, keywordToRedo, keywordToUndo },
  } = action;
  let keyword: IKeyWords;
  if (operation === 'undo') {
    redoKeyword?.push(state.keyWords);
    keyword = redoKeyword?.pop();
    const keywordToDelete = keyword.formattedKeyword.find(
      (keywordDefinition: IKeywordDefinition) =>
        keywordDefinition.id === keywordToUndo[0].keywordId
    );
    const allKeyword = state.keyWords.allKeyword.filter(
      (item: IKeyWord) => item.keyWordId !== keywordToDelete.id
    );
    state.keyWords = formatKeyword(allKeyword);
    keyword = state.keyWords;
  } else {
    undoKeyword?.push(state.keyWords);
    let allKeyword = [];
    undoKeyword.forEach((keywordsRedo: IKeyWords) => {
      if (keywordsRedo.allId.includes(keywordToRedo[0].keywordId)) {
        allKeyword = keywordsRedo.allKeyword;
      }
    });
    state.keyWords = formatKeyword(allKeyword);
    keyword = state.keyWords;
  }
  return {
    ...state,
    editorRedo: { keywords: [...redoKeyword] },
    editorUndo: { keywords: [...undoKeyword] },
    keyWords: { ...keyword },
  };
}

function traverseKeyword(state: AppState, action: KeywordTraverseAction) {
  let { keyword, idToSelect } = action.payload;
  if (state.keyWords.keywordTraverse?.id === keyword.id) {
    const { keywordTraverse } = state.keyWords;
    while (keywordTraverse.altLabels[0].id !== idToSelect) {
      const altLabel = keywordTraverse.altLabels.shift();
      keywordTraverse.preferedLabelId = keywordTraverse.altLabels[0].id;
      keywordTraverse.altLabels.push(altLabel);
    }
    keyword = keywordTraverse;
  }
  return {
    ...state,
    keyWords: {
      ...state.keyWords,
      selected: keyword,
      keywordTraverse: keyword,
    },
  };
}

function AllDocsDashboardAddItem(
  state: AppState,
  action: AllDocsDashboardAddItemAction
) {
  const newState = { ...state };
  const allDocs = state.allDocsDashboardSelection[`page ${action.pageNumber}`]
    ? state.allDocsDashboardSelection[`page ${action.pageNumber}`]
    : [];
  newState.allDocsDashboardSelection = {
    ...state.allDocsDashboardSelection,
    [`page ${action.pageNumber}`]: [...allDocs, action.payload],
  };
  return newState;
}

function AllDocsDashboardRemoveItem(
  state: AppState,
  action: AllDocsDashboardRemoveItemAction
) {
  const newState = { ...state };
  const newAll = { ...state.allDocsDashboardSelection };
  newState.allDocsDashboardSelection = {
    ...newAll,
    [`page ${action.pageNumber}`]: newAll[`page ${action.pageNumber}`].filter(
      (el) => {
        return action.payload.entry.id !== el.entry.id;
      }
    ),
  };
  return newState;
}

function AllDocsDashboardDeselectAll(state: AppState) {
  return {
    ...state,
    allDocsDashboardSelection: {},
  };
}

function SetUserRoleForCurrentSite(
  state: AppState,
  action: SetUserRoleForCurrentSiteAction
) {
  return {
    ...state,
    currentSiteUserRole: action.payload,
  };
}

function showLoader(state: AppState, action: ShowLoaderAction): AppState {
  const newState = { ...state };
  newState.showLoader = action.payload;
  return newState;
}
